import React, { useState } from 'react';
import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  FormFeedback,
  FormGroup,
} from 'reactstrap';
import IntlMessages from "../../../../../helpers/IntlMessages";
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { postAPI_Update_Inventory } from '../../../../../constants/APIs';

// Redux
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Validation from '../../../../../components/Validation';

import { Formik, FieldArray } from 'formik';
import * as Yup from 'yup';
import { Form } from 'formik'; // Import Form from formik directly

// Validation schema using Yup
const InventorySchema = Yup.object().shape({
  items: Yup.array().of(
    Yup.object().shape({
      roomTypeId: Yup.string().required('Choose the room type!'),
      startDate: Yup.date().required('Choose the start date!'),
      endDate: Yup.date().required('Choose the end date!'),
      count: Yup.number().min(0, 'Inventory must be >= 0').required('Enter inventory count'),
    })
  ),
});

function InventoryEditModal({ isVisible, toggleModal, propertyId, roomlist }) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);

  const handleUpdate = (values) => {
    AxiosAPI({
      url: postAPI_Update_Inventory,
      method: 'post',
      data: {
        propertyId,
        data: values.items,
      },
    })
      .then((res) => {
        if (
          res.data.HttpStatusCode === 400 &&
          res.data.Messages &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  return (
    <div>
      <Modal size="lg" isOpen={isVisible} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Bulk Edit</ModalHeader>

        <Formik
          initialValues={{
            items: [{ roomTypeId: '', startDate: '', endDate: '', count: 0 }],
          }}
          validationSchema={InventorySchema}
          onSubmit={handleUpdate}
        >
          {({ values, errors, touched, handleChange, handleBlur }) => (
            <Form>
              <ModalBody>
                <FieldArray
                  name="items"
                  render={(arrayHelpers) => (
                    <>
                      {values.items.map((item, index) => (
                        <Row key={index}>
                          <Colxx sm={3} className="mb-3">
                            <FormGroup>
                              <Label>
                                <IntlMessages id="dashboards.room-type" />
                              </Label>
                              <Input className='input_sty'
                                type="select"
                                name={`items.${index}.roomTypeId`}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={item.roomTypeId}
                                invalid={!!(errors.items?.[index]?.roomTypeId && touched.items?.[index]?.roomTypeId)}
                              >
                                <option value="" disabled hidden>
                                  Room Type
                                </option>
                                {roomlist.map((elem, idx) => (
                                  <option value={elem.roomTypeId} key={idx}>
                                    {elem.roomName}
                                  </option>
                                ))}
                              </Input>
                              {errors.items?.[index]?.roomTypeId && touched.items?.[index]?.roomTypeId && (
                                <FormFeedback>
                                  {errors.items[index].roomTypeId}
                                </FormFeedback>
                              )}
                            </FormGroup>
                          </Colxx>

                          <Colxx sm={3} className="mb-3">
                            <FormGroup>
                              <Label>
                                <IntlMessages id="dashboards.start-date" />
                              </Label>
                              <Input className='input_sty'
                                type="date"
                                name={`items.${index}.startDate`}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={item.startDate}
                                invalid={!!(errors.items?.[index]?.startDate && touched.items?.[index]?.startDate)}
                              />
                              {errors.items?.[index]?.startDate && touched.items?.[index]?.startDate && (
                                <FormFeedback>
                                  {errors.items[index].startDate}
                                </FormFeedback>
                              )}
                            </FormGroup>
                          </Colxx>

                          <Colxx sm={3} className="mb-3">
                            <FormGroup>
                              <Label>
                                <IntlMessages id="dashboards.end-date" />
                              </Label>
                              <Input className='input_sty'
                                type="date"
                                name={`items.${index}.endDate`}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={item.endDate}
                                invalid={!!(errors.items?.[index]?.endDate && touched.items?.[index]?.endDate)}
                              />
                              {errors.items?.[index]?.endDate && touched.items?.[index]?.endDate && (
                                <FormFeedback>
                                  {errors.items[index].endDate}
                                </FormFeedback>
                              )}
                            </FormGroup>
                          </Colxx>

                          <Colxx sm={3} className="mb-3">
                            <FormGroup>
                              <Label>Inventory</Label>
                              <Input className='input_sty'
                                type="number"
                                name={`items.${index}.count`}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={item.count}
                                invalid={!!(errors.items?.[index]?.count && touched.items?.[index]?.count)}
                              />
                              {errors.items?.[index]?.count && touched.items?.[index]?.count && (
                                <FormFeedback>
                                  {errors.items[index].count}
                                </FormFeedback>
                              )}
                            </FormGroup>
                          </Colxx>

                          <Colxx sm={12} className="mb-3">
                            <div className="d-flex justify-content-start align-items-center">
                              <Button
                                className="mr-2"
                                onClick={() =>
                                  arrayHelpers.push({
                                    roomTypeId: '',
                                    startDate: '',
                                    endDate: '',
                                    count: 0,
                                  })
                                }
                                color="primary"
                                size="xs"
                                outline
                                type="button"
                              >
                                + Add More
                              </Button>
                              {values.items.length > 1 && (
                                <Button
                                  onClick={() => arrayHelpers.remove(index)}
                                  color="secondary"
                                  size="xs"
                                  outline
                                  type="button"
                                >
                                  -
                                </Button>
                              )}
                            </div>
                          </Colxx>
                        </Row>
                      ))}
                    </>
                  )}
                />
              </ModalBody>

              <ModalFooter>
                <Button color="primary" type="submit">
                  Update
                </Button>
                <Button color="secondary" onClick={toggleModal} type="button">
                  Cancel
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>

      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      />
    </div>
  );
}

export default connect()(injectIntl(InventoryEditModal));
